import type { RootState } from '../store';
import type { ProductsCategory } from './productModels';

// Select all products grouped by category
export const selectAllProductsCategory = (state: RootState) => 
  state.products.productsCategory;

// Select current product details
export const selectCurrentProduct = (state: RootState) => 
  state.products.currentProduct;

// Select related products
export const selectRelatedProducts = (state: RootState) => 
  state.products.relatedProducts;

// Select loading state
export const selectProductsLoading = (state: RootState) => 
  state.products.loading;

// Select error state
export const selectProductsError = (state: RootState) => 
  state.products.error;

// Select status
export const selectProductsStatus = (state: RootState) => 
  state.products.status;

// Select all products flattened (helper selector)
export const selectAllProducts = (state: RootState) => {
  return state.products.productsCategory.flatMap((category: ProductsCategory) => category.products);
};

// Select products by category name
export const selectProductsByCategoryName = (categoryName: string) => (state: RootState) => {
  const category = state.products.productsCategory.find(
    (cat: ProductsCategory) => cat.products.length > 0 && cat.products[0].categoryName === categoryName
  );
  return category?.products || [];
};

// Select model products
export const selectModelProducts = (state: RootState) => state.products.modelProducts;

